import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { UserDataService } from 'src/app/shared/providers/user-data.service';
import { INavpanelAction, NAVPANEL_ACTION_TYPE } from 'src/app/models/card';
import { DialogData, ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { POPUP_TEXT } from 'src/app/shared/text/popup-texts';
import { WebUploadService } from '../webupload.service';
import { CardsService } from 'src/app/shared/providers/cards.service';
import { Subscription } from 'rxjs';
import { UtilityFunctionsService } from 'src/app/shared/providers/utility-functions.service';

@Component({
  selector: 'app-websubscription',
  templateUrl: './websubscription.component.html',
  styleUrls: ['./websubscription.component.scss']
})
export class WebsubscriptionComponent implements OnInit, OnDestroy {
  @Output() websubscriptionclicked = new EventEmitter<INavpanelAction>();

  mainBtnTitle: string = 'Join';
  isDisabled: boolean;
  appActivationSubscription: Subscription;

  constructor(
    public userDataService: UserDataService,
    public dialog: MatDialog,
    public utilityService: UtilityFunctionsService,
    public uploadService: WebUploadService,
    public cardService: CardsService,
    public dialogRef: MatDialogRef<WebsubscriptionComponent>,
    @Inject(MAT_DIALOG_DATA) public activatedAfterStripeRedirect: boolean
  ) {
    this.isDisabled = activatedAfterStripeRedirect;
  }

  ngOnInit(): void {
    // Subscription is now handled in the shared component
  }

  onMainBtnClick(): void {
    console.log('websubscriptionclicked');
    if (this.uploadService.getIsNoUploadInProgress()) {
      this.websubscriptionclicked.emit({ actionName: 'Stripe Hosted Checkout', actionType: NAVPANEL_ACTION_TYPE.STRIPE_HOSTED_CHECKOUT });
      this.isDisabled = true;
    } else {
      this.openGoToStripeConfirmation();
    }
  }

  onBackClick(): void {
    this.dialogRef.close();
  }

  onFreeTrialClick(): void {
    this.websubscriptionclicked.emit({ actionName: 'Free trial activation', actionType: NAVPANEL_ACTION_TYPE.FREE_TRIAL_ACTIVATION });
    console.log('onFreeTrialClick');
  }

  public openGoToStripeConfirmation() {
    const dialogConfig: MatDialogConfig<DialogData> = {
      data: this.utilityService.applyPopupText(POPUP_TEXT.SUBSCRIPTION_PROCEED)
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.isDisabled = true;
        this.websubscriptionclicked.emit({ actionName: 'Stripe Hosted Checkout', actionType: NAVPANEL_ACTION_TYPE.STRIPE_HOSTED_CHECKOUT });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.appActivationSubscription) {
      this.appActivationSubscription.unsubscribe();
    }
  }
}
